module.exports = __webpack_public_path__ + "img/b2e58cf.png";